<div class="container mx-auto">
  <h1 class="text-2xl font-bold mb-4">
    @if (isCreateMode) { {{ 'USER_GROUPS.MANAGE.CREATE_TITLE' | translate }} } @else { {{ 'USER_GROUPS.MANAGE.EDIT_TITLE' | translate }} }
  </h1>

  @if (error) {
    <app-alert [type]="'danger'">{{ error }}</app-alert>
  }

  @if (loading) {
    <div class="mb-4"><app-loading size="large" color="primary" /></div>
  } @else {
    <form [formGroup]="form" (ngSubmit)="submit()" class="space-y-4">
      <div>
        <label class="block text-sm font-medium mb-1">{{ 'USER_GROUPS.MANAGE.NAME' | translate }}</label>
        <input type="text" formControlName="name" class="form-input w-full py-2 px-3 h-10 bg-transparent dark:bg-neutral-900 dark:text-slate-200 rounded outline-none border border-gray-200 focus:border-slate-600 dark:border-neutral-900 dark:focus:border-slate-600 focus:ring-0" />
      </div>
      <div>
        <label class="block text-sm font-medium mb-1">{{ 'USER_GROUPS.MANAGE.DESCRIPTION' | translate }}</label>
        <textarea formControlName="description" class="form-textarea w-full py-2 px-3 h-10 bg-transparent dark:bg-neutral-900 dark:text-slate-200 rounded outline-none border border-gray-200 focus:border-slate-600 dark:border-neutral-900 dark:focus:border-slate-600 focus:ring-0"></textarea>
      </div>

      <div>
        <label class="block text-sm font-medium mb-1">{{ 'USER_GROUPS.MANAGE.ROLES' | translate }}</label>
        <div>
          <p-pickList
            #pickList
            [source]="deselectedColumns"
            [target]="selectedColumns"
            [dragdrop]="true"
            [responsive]="true"
            (onMoveAllToTarget)="onMoveAllToTarget($event)"
            (onMoveAllToSource)="onMoveAllToSource($event)"
            filterBy="name"
            sourceFilterPlaceholder="Search by name"
            targetFilterPlaceholder="Search by name"
            breakpoint="1400px"
            class="w-full">
            <ng-template let-item #item>
              {{ item.name }}
            </ng-template>
          </p-pickList>
        </div>
      </div>

      <div class="mt-4">
        <h2 class="text-xl font-semibold mb-2">{{ 'USER_GROUPS.MANAGE.USERS_PLACEHOLDER_TITLE' | translate }}</h2>
        <table class="table-auto w-full border-collapse border border-slate-400">
          <thead>
          <tr>
            <td class="border border-neutral-300 dark:border-neutral-600 p-2">{{ 'USER_GROUPS.MANAGE.LIST.ID' | translate }}</td>
            <td class="border border-neutral-300 dark:border-neutral-600 p-2">{{ 'USER_GROUPS.MANAGE.LIST.NAME' | translate }}</td>
            <td class="border border-neutral-300 dark:border-neutral-600 p-2">{{ 'USER_GROUPS.MANAGE.LIST.EMAIL' | translate }}</td>
            <td class="border border-neutral-300 dark:border-neutral-600 p-2">&nbsp;</td>
          </tr>
          </thead>
          <tbody>
          @for (user of members; track user.id) {
            <tr>
              <td class="border border-neutral-300 dark:border-neutral-600 p-2">{{ user.id }}</td>
              <td class="border border-neutral-300 dark:border-neutral-600 p-2">{{ user.userName }}</td>
              <td class="border border-neutral-300 dark:border-neutral-600 p-2">{{ user.email }}</td>
              <td class="border border-neutral-300 dark:border-neutral-600 p-2">
                <a class="flex items-center justify-center underline" [routerLink]="['/users/edit', user.id]" target="_blank">
                  <i class="h-4 w-4 me-3 text-base mr-1 border-white" [innerHTML]="'eye' | feather: { width: 16, height: 16 }"></i>
                </a>
              </td>
            </tr>
          } @empty {
            <tr>
              <td colspan="4" class="border border-neutral-300 dark:border-neutral-600 p-2">
                @if (paginationModel().loading) {
                  <div class="my-4">
                    <app-loading size="large" color="primary"/>
                  </div>
                } @else {
                  {{ 'USER_GROUPS.MANAGE.LIST.NO_USERS' | translate }}
                }
              </td>
            </tr>
          }
          </tbody>
        </table>
        <app-pagination [paginationState]="paginationModel()" [onPaginationChange]="loadUsers"></app-pagination>
      </div>

      <div class="flex space-x-2">
        <app-button color="primary" type="submit">{{ isCreateMode ? ('COMMON.SAVE' | translate) : ('COMMON.UPDATE' | translate) }}</app-button>
        <app-button color="secondary" type="button" (click)="cancel()">{{ 'COMMON.CANCEL' | translate }}</app-button>
      </div>
    </form>
  }
</div>
